import React, {Component} from 'react';
import {connect} from 'react-redux'
import {
    AppBar,
    Button,
    Card,
    CardContent, Input,
    Toolbar,
    Typography
} from '@material-ui/core';
import {withRouter} from "react-router-dom";
import ReactTable from "react-table";
import {FuseAnimate} from "../../../../../@fuse";
import {UecareDropdown} from "../../../../../components";
import {bindActionCreators} from "redux";
import ReduxCallHelper from "../../../../../store/actionreducers/callHelper";
import ReduxInstitution from "../../../../../store/actionreducers/institution";
import ReduxGlobal from "../../../../../store/actionreducers/globalView";

class BasicInfoTab extends Component {

    state = {
        actionType: 'view', // view . add . edit
        is_show_map: false,
        is_show_hospital_list: false,
        zoom: 11,
        hospital: {lat: 0, lng: 0}
    };

    /*
    componentDidMount() {
        const {medical} = this.props;
        const hospital = medical.institution;
        const name = (hospital) ? hospital.name : medical.unvalidated_hospital_name;
        this.setState({hospital: {...medical.hospital, name}});
    }
    */

    componentWillReceiveProps(newProps,nextContexts) {
        const {medical} = newProps; // this.props;
        const hospital = medical.institution;
        const name = (hospital) ? hospital.name : medical.unvalidated_hospital_name;
        this.setState({hospital: {...medical.hospital, name}});
    }

    _getLat() {
        return this.state.hospital.lat || 0;
    }

    _getLng() {
        return this.state.hospital.lng || 0;
    }

    handleCityChange = (city) => {
        this.setState({hospital: {...this.state.hospital, city}});
    };

    handleHospitalNameChange = (name) => {
        this.setState({hospital: {...this.state.hospital, name}});
    };

    handleHospitalTypeChange = (type) => {
        this.setState({hospital: {...this.state.hospital, type}});
    };

    handleHospitalAddressChange = (address) => {
        this.setState({hospital: {...this.state.hospital, address}});
    };

    render() {
        const {actionType, hospital, is_show_hospital_list} = this.state;
        const {institutions, cities, medicalChangeHospital, newInstitution, medical, openLoadingMask, closeLoadingMask, openErrorDialog} = this.props;

        const data = institutions.map((institution) => {

            const typeMap = {
                hospital: '醫院',
                clinic: '診所',
                pharmacy: '藥局',
            };

            return {...institution, type: typeMap[institution.type]}
        });

        if (actionType === 'view') {

            return (
                <div>
                    <Card className="w-full mb-16">
                        <AppBar position="static" elevation={0}>
                            <Toolbar className="pl-16 pr-8">
                                <div className="flex flex-1 flex-row justify-between items-center">
                                    <Typography variant="subheading" color="inherit">
                                        服務機構
                                    </Typography>
                                    <Button variant="contained"
                                            color="secondary"
                                            className="m-8 bg-blue hover:bg-blue-dark"
                                            onClick={() => {
                                                this.setState({ is_show_hospital_list: !is_show_hospital_list});
                                            }}>
                                        {(is_show_hospital_list) ? '關閉機構選單' : '開啟機構選單'}
                                    </Button>
                                </div>
                            </Toolbar>
                        </AppBar>

                        <CardContent>
                            <div className="flex flex-1 flex-col md:flex-row">

                                <div className={`flex flex-1 flex-col ${(is_show_hospital_list) ? 'md:ml-16' : ''}`}>
                                    <div className="mb-24">
                                        <Button variant="contained"
                                                color="secondary"
                                                className="m-8 bg-green hover:bg-green-darker"
                                                disabled={!(hospital.id)}
                                                onClick={async () => {
                                                    try {
                                                        openLoadingMask();
                                                        const medicalId = medical.id;
                                                        const hospitalId = hospital.id;
                                                        await medicalChangeHospital({medicalId, hospitalId});
                                                        closeLoadingMask();
                                                        this.closeDataDialog();
                                                    } catch (e) {
                                                        console.warn('you got an error = ', e);
                                                    }
                                                }}>
                                            變更所屬醫療機構
                                        </Button>
                                        <Button variant="contained"
                                                color="secondary"
                                                className="m-8 bg-green hover:bg-green-dark"
                                                disabled={!!(hospital.id) || hospital.name === "" || hospital.address === "" || hospital.type === ""}
                                                onClick={async () => {
                                                    try {
                                                        openLoadingMask();
                                                        const medicalId = medical.id;
                                                        if(hospital.name === "" || hospital.address === "" ){
                                                            openErrorDialog();
                                                            return;
                                                        }
                                                        const newHospital = await newInstitution(hospital);
                                                        const hospitalId = newHospital.id;
                                                        await medicalChangeHospital({medicalId, hospitalId});
                                                        closeLoadingMask();

                                                        this.closeDataDialog();
                                                    } catch (e) {
                                                        console.warn('you got an error = ', e);
                                                    }
                                                }}>
                                            新建機構
                                        </Button>
                                        <Button variant="contained"
                                                color="secondary"
                                                className="m-8 bg-red hover:bg-red-dark"
                                                onClick={() => {
                                                    this.setState({hospital: {...hospital, id: undefined, name: '', type: '', address:'', level:'', lat:'', lng:'', website:'', tel_no:'',public_or_private:''}});
                                                }}>
                                            清除選取/編輯資料
                                        </Button>
                                    </div>
                                    <div className="mb-24">
                                        <Typography className="font-bold mb-4 text-15">機構編號</Typography>
                                        <Typography>{hospital.id}</Typography>
                                    </div>
                                    <div className="mb-24">
                                        <Typography className="font-bold mb-4 text-15">縣市</Typography>
                                        <div className="float-left w-128">
                                            <UecareDropdown value={(hospital.city && hospital.city.id) || 0}
                                                            options={cities}
                                                            disabled={!!(hospital.id)}
                                                            onChange={(event, selectedOption) => {
                                                                this.handleCityChange(selectedOption);
                                                            }}/>
                                        </div>
                                    </div>
                                    <div className="mb-24">
                                        <Typography className="font-bold mb-4 text-15">名稱</Typography>
                                        {
                                            (hospital.id) ?
                                                <Typography>{hospital.name}</Typography>
                                                :
                                                <Input value={hospital.name}
                                                       onChange={(event) => {
                                                           this.handleHospitalNameChange(event.target.value);
                                                       }}/>
                                        }
                                    </div>
                                    <div className="mb-24">
                                        <Typography className="font-bold mb-4 text-15">地址</Typography>
                                        {
                                            (hospital.id) ?
                                                <Typography>{hospital.address}</Typography>
                                                :
                                                <Input value={hospital.address}
                                                       onChange={(event) => {
                                                           this.handleHospitalAddressChange(event.target.value);
                                                       }}/>
                                        }
                                    </div>
                                    <div className="mb-24">
                                        <Typography className="font-bold mb-4 text-15">類型</Typography>
                                        {
                                            (hospital.id) ?
                                                <Typography>{hospital.type}</Typography>
                                                :
                                                <Input value={hospital.type}
                                                       onChange={(event) => {
                                                           this.handleHospitalTypeChange(event.target.value);
                                                       }}/>
                                        }
                                    </div>
                                </div>
                                {
                                    (is_show_hospital_list) ?
                                        <FuseAnimate animation="transition.slideUpIn" delay={300}>
                                            <ReactTable
                                                previousText='Previous'
                                                nextText='Next'
                                                loadingText='Loading...'
                                                noDataText="目前沒有任何醫療機構"
                                                pageText='頁'
                                                ofText='/共'
                                                rowsText='筆'
                                                className="-striped -highlight"
                                                data={data || []}
                                                defaultPageSize={5}
                                                getTrProps={(state, rowInfo, column) => {
                                                    return {
                                                        className: "cursor-pointer",
                                                        onClick: (e, handleOriginal) => {
                                                            if (rowInfo) {
                                                                this.setState({hospital: rowInfo.original});
                                                            }
                                                        }
                                                    }
                                                }}
                                                columns={[
                                                    {
                                                        Header: "類型",
                                                        accessor: "type",
                                                        filterable: true,
                                                        width: 60,
                                                        className: "font-bold"
                                                    },
                                                    {
                                                        Header: "縣市",
                                                        accessor: "city.name",
                                                        filterable: true,
                                                        width: 100,
                                                        className: "font-bold"
                                                    },
                                                    {
                                                        Header: "名稱",
                                                        accessor: "name",
                                                        filterable: true,
                                                        width: 150,
                                                        className: "font-bold"
                                                    },
                                                    {
                                                        Header: "連絡電話",
                                                        accessor: "tel_no",
                                                        width: 96,
                                                        filterable: true
                                                    },
                                                    {
                                                        Header: "地址",
                                                        accessor: "address",
                                                        filterable: true,
                                                        width: 256,
                                                    },
                                                ]}
                                            />
                                        </FuseAnimate> : ''
                                }
                            </div>
                        </CardContent>
                    </Card>
                </div>
            );
        } else {
            return (<div/>);
        }
    }
}


function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        medicalChangeHospital: ReduxCallHelper.ActionCreator.medicalChangeHospital,
        newInstitution: ReduxInstitution.ActionCreator.newInstitution,
        openLoadingMask: ReduxGlobal.ActionCreator.openLoadingMask,
        closeLoadingMask: ReduxGlobal.ActionCreator.closeLoadingMask,
        openErrorDialog: ReduxGlobal.ActionCreator.openErrorDialog,
    }, dispatch);
}


function mapStateToProps({callHelper: {medical}, institution, city: {cities}}) {

    const hospitals = institution.list.filter((institution) => {
        return institution.type === 'hospital';
    });

    return {
        medical,
        cities,
        hospitals,
        institutions: institution.list
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(BasicInfoTab));



// WEBPACK FOOTER //
// ./src/main/content/callHelper/medical/tabs/HospitalTab.js